import * as React from 'react';
import { loadScript } from '@/utils';
import { useMemoizedFn } from 'ahooks';

const MIN_SCROLL_TOP = 30;
const MIN_SCROLL_CORRECT_POS = 72;
const NORMAL_SCROLL_CORRECT_POS = 110;

const { useEffect } = React;

const useGoogleOneTap = () => {
  // oneTap回调
  const handleGoogleOneTapCallback = useMemoizedFn(async ({ credential }) => {
    if (typeof window === 'undefined') return;
    const origin = window.location.origin;
    if (origin.includes('dev')) {
      window.open(`https://dev-c0ee1fac76df136a.notta.ai/google-one-tap?credential=${credential}`, '_blank');
    } else if (origin.includes('test')) {
      window.open(`https://test-app-12154205867b06a3.notta.ai/google-one-tap?credential=${credential}`, '_blank');
    } else {
      window.open(`https://app.notta.ai/google-one-tap?credential=${credential}`, '_blank');
    }
  });

  // 配置oneTap初始化
  const googleOneTapLogin = useMemoizedFn(() => {
    window['google'].accounts.id.initialize({
      client_id: '53779308283-bgqhd5g489j8vhftkhc1vs89m13t3clr.apps.googleusercontent.com',
      prompt_parent_id: 'id_google_one_tap',
      auto_select: false,
      callback: handleGoogleOneTapCallback,
      cancel_on_tap_outside: false,
    });

    window['google'].accounts.id.prompt((notification) => {
      // oneTap界面显示
      if (notification.isDisplayed()) {
        correctionPosition();
      }
      // one tap 因自动取消、手动取消或 Google 无法颁发凭据（例如所选会话已退出 Google 帐号）而关闭时，就会发生这种情况。
      if (notification.isSkippedMoment()) {
      }
    });
  });

  // 调整oneTap位置
  const correctionPosition = useMemoizedFn((top = 0) => {
    const credentialElement = document.getElementById('credential_picker_container');
    if (!credentialElement) return;

    if (!!top) {
      const currentTop = credentialElement.getBoundingClientRect().top;
      if (currentTop !== top) {
        credentialElement.style.top = `${top}px`;
      }
      return;
    }

    credentialElement.style.top =
      window.location.pathname === '/' ? `${NORMAL_SCROLL_CORRECT_POS}px` : `${MIN_SCROLL_CORRECT_POS}px`;
  });

  // 主页滑动监听
  const handleHomepageScroll = useMemoizedFn(() => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > MIN_SCROLL_TOP) {
      correctionPosition(MIN_SCROLL_CORRECT_POS);
    }
    if (scrollTop === 0) {
      correctionPosition(NORMAL_SCROLL_CORRECT_POS);
    }
  });

  // 加载脚本
  useEffect(() => {
    // Notta web登陆后会把 v1_token 储存在 notta.ai 域名下供其他子域名判断登录状态
    if (document.cookie.indexOf('v1_token') === -1) {
      loadScript('https://accounts.google.com/gsi/client', 'google-one-tap')
        .then(googleOneTapLogin)
        .catch((error) => {});
    }
  }, []);

  // 监听路由调整oneTap位置
  useEffect(() => {
    correctionPosition();
  }, [typeof window !== 'undefined' && window.location.pathname, correctionPosition]);

  // 首页监听滑动距离调整oneTap位置
  useEffect(() => {
    if (window.location.pathname !== '/') return;
    window.addEventListener('scroll', handleHomepageScroll);
    return () => {
      window.removeEventListener('scroll', handleHomepageScroll);
    };
  }, []);
};

export default useGoogleOneTap;
